import gsap from 'gsap';
import React, { useEffect, useRef } from 'react';
import styled, { css } from 'styled-components';
import { IconBase } from '../Base';
const Wrapper = styled.div ``;
const Paper = styled.g `
  fill: var(--icon-background, ${({ theme }) => theme.background});
`;
const Line = styled.path `
  stroke-dasharray: 5px;
  stroke-dashoffset: 10px;

  ${({ isHidden }) => isHidden &&
    css `
      stroke-dashoffset: 15px;
    `}
`;
export const IconCalendar = ({ className, onDone, running }) => {
    const wrapperRef = useRef(null);
    const backPaperRef = useRef(null);
    const frontPaperRef = useRef(null);
    const triggerDone = () => {
        if (onDone) {
            onDone();
        }
    };
    useEffect(() => {
        if (running) {
            const backPaper = backPaperRef.current;
            const backPaperLines = backPaper?.querySelectorAll('g path');
            const frontPaper = frontPaperRef.current;
            if (frontPaper && backPaper && backPaperLines) {
                gsap.to(frontPaper, {
                    keyframes: [
                        {
                            y: 8,
                            x: -1,
                            rotate: '15deg',
                            duration: 0.4,
                            onStart: () => {
                                gsap.to(frontPaper, {
                                    delay: 0.2,
                                    opacity: 0,
                                    duration: 0.2,
                                });
                                gsap.to(backPaperLines, {
                                    stagger: 0.1,
                                    delay: 0.25,
                                    strokeDashoffset: '10px',
                                    duration: 0.15,
                                });
                            },
                        },
                        {
                            duration: 0.5,
                            clearProps: true,
                            onComplete: () => {
                                gsap.set(backPaperLines, {
                                    strokeDashoffset: '15px',
                                });
                                triggerDone();
                            },
                        },
                    ],
                });
            }
        }
    }, [running]);
    return (React.createElement(Wrapper, { className: className, ref: wrapperRef },
        React.createElement(IconBase, null,
            React.createElement("g", { strokeWidth: "1.5", style: { stroke: 'var(--icon-color)' } },
                React.createElement("path", { d: "M15.3191 6.66666H16.2033C16.92 6.66666 17.5 7.24666 17.5 7.96333V16.2042C17.5 16.92 16.92 17.5 16.2033 17.5H7.12998C6.41331 17.5 5.83331 16.92 5.83331 16.2033V15" }),
                React.createElement(Paper, { ref: backPaperRef },
                    React.createElement("path", { d: "M3.33417 15H12.7608C13.3183 15 13.8383 14.7217 14.1475 14.2575L14.7592 13.3392C15.1243 12.7916 15.3192 12.1482 15.3192 11.49V5C15.3192 4.55798 15.1436 4.13405 14.831 3.82149C14.5185 3.50893 14.0945 3.33334 13.6525 3.33334H5.31917C4.87714 3.33334 4.45322 3.50893 4.14066 3.82149C3.8281 4.13405 3.6525 4.55798 3.6525 5V10.88C3.6525 11.3975 3.53167 11.9075 3.30084 12.3708L2.58917 13.7942C2.5257 13.9212 2.49574 14.0623 2.50213 14.2042C2.50851 14.346 2.55104 14.4839 2.62567 14.6047C2.70031 14.7255 2.80457 14.8252 2.92856 14.8944C3.05256 14.9636 3.19218 14.9999 3.33417 15Z" }),
                    React.createElement("g", { strokeLinecap: "round" },
                        React.createElement(Line, { d: "M6.82501 7.5H11.825", isHidden: true }),
                        React.createElement(Line, { d: "M6.82501 10.8333H11.825", isHidden: true }))),
                React.createElement(Paper, { ref: frontPaperRef },
                    React.createElement("path", { d: "M3.33417 15H12.7608C13.3183 15 13.8383 14.7217 14.1475 14.2575L14.7592 13.3392C15.1243 12.7916 15.3192 12.1482 15.3192 11.49V5C15.3192 4.55798 15.1436 4.13405 14.831 3.82149C14.5185 3.50893 14.0945 3.33334 13.6525 3.33334H5.31917C4.87714 3.33334 4.45322 3.50893 4.14066 3.82149C3.8281 4.13405 3.6525 4.55798 3.6525 5V10.88C3.6525 11.3975 3.53167 11.9075 3.30084 12.3708L2.58917 13.7942C2.5257 13.9212 2.49574 14.0623 2.50213 14.2042C2.50851 14.346 2.55104 14.4839 2.62567 14.6047C2.70031 14.7255 2.80457 14.8252 2.92856 14.8944C3.05256 14.9636 3.19218 14.9999 3.33417 15Z" }),
                    React.createElement("g", { strokeLinecap: "round" },
                        React.createElement(Line, { d: "M6.82501 7.5H11.825" }),
                        React.createElement(Line, { d: "M6.82501 10.8333H11.825" }))),
                React.createElement("g", { strokeLinecap: "round" },
                    React.createElement("path", { d: "M6.98334 2.5V4.16667" }),
                    React.createElement("path", { d: "M11.9833 2.5V4.16667" }))))));
};
//# sourceMappingURL=Calendar.js.map